import { memo } from 'react';

// Sidebar icon for Admins. A shield reads as "privileged account" and stays
// distinct from Users (person in a circle) at 20px. Stroke colours and width
// match the other nav icons so the active/inactive states line up.
const SvgComponent = (props: any) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 1.5 3.2 4.3v5.1c0 4.2 2.9 8.1 6.8 9.1 3.9-1 6.8-4.9 6.8-9.1V4.3L10 1.5Z"
      stroke={props.active ? '#3C3C60' : '#808080'}
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    <path
      d="m7.1 9.9 2 2 3.8-3.8"
      stroke={props.active ? '#3C3C60' : '#808080'}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const Memo = memo(SvgComponent);

export default Memo;
